import styled from '../styled';

export const Centered = styled('div')<{ height?: string | number }>((p) => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  flexDirection: 'column',
  minHeight: p.height || 'auto',

  '> :not(:first-child)': {
    marginTop: p.theme.spacing()
  }
}));
